
import { BaseAPI } from "../../BaseAPI";
import * as environment from '../../../config/environment';

class AboneNumarasiSorgulaAPI extends BaseAPI {


    constructor() {
        const baseUrl = environment.API_URL + "AboneListele/AboneListele";
        super(baseUrl);
    }


    AboneListele(request: AboneNumarasiSorgulaRequest) {

        return this.post("", request);

    }

}
export default new AboneNumarasiSorgulaAPI();

class AboneNumarasiSorgulaRequest {
    sicilKodu: string;
    vatandaslikNo: string;

    constructor(
        sicilKodu: string,
        vatandaslikNo: string,
    ) {
        this.sicilKodu = sicilKodu;
        this.vatandaslikNo = vatandaslikNo;
    }
}
export { AboneNumarasiSorgulaRequest };